module.exports = __webpack_public_path__ + "static/media/13@1280w.6f3d6740.jpg";